import { render, staticRenderFns } from "./PagingComponent.vue?vue&type=template&id=6d2f9eba"
import script from "./PagingComponent.vue?vue&type=script&lang=js"
export * from "./PagingComponent.vue?vue&type=script&lang=js"
import style0 from "./PagingComponent.vue?vue&type=style&index=0&id=6d2f9eba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports